import { Check, Delete, Edit } from "@mui/icons-material";
import { Box, Grid, IconButton, Paper, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const ApplicationTypesTable = ({ rows = [], onEdit = () => { }, onDelete = () => { } }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    if (!rows || !rows.length) return null;

    if (isMobile) {
        // 📱 Mobile layout: stacked cards
        return (
            <Box sx={{ mt: 2 }}>
                {rows.map((row, idx) => (
                    <Paper
                        key={row.id || idx}
                        elevation={0}
                        sx={{
                            border: "1px solid #dcdcdc",
                            borderRadius: 1.5,
                            mb: 1.5,
                            p: 2,
                            backgroundColor: row.isActive ? "#f9fff9" : "#fff",
                        }}
                    >
                        <Typography color="primary" fontWeight={700}>
                            {row.id}
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Τίτλος:{" "}
                            <Typography component="span" color="text.primary">
                                {row.description}
                            </Typography>
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Σύντμηση:{" "}
                            <Typography component="span" color="text.primary">
                                {row.abbr}
                            </Typography>
                        </Typography>

                        {row.isActive && (
                            <Typography
                                variant="body2"
                                sx={{ mt: 0.5, fontWeight: 600, color: "success.dark" }}
                            >
                                ✓ Ενεργός Τύπος Αίτησης
                            </Typography>
                        )}
                    </Paper>
                ))}
            </Box>
        );
    }

    // 🖥️ Desktop layout: your original table-like grid
    return (
        <Box
            sx={{
                border: "1px solid #dcdcdc",
                borderRadius: 1.5,
                overflow: "hidden",
                mt: 2,
            }}
        >
            {/* Header */}
            <Grid
                container
                sx={{
                    backgroundColor: "#f2f2f2",
                    borderBottom: "1px solid #dcdcdc",
                    py: 1,
                    px: 2,
                }}
            >
                <Grid item xs={2}>
                    <Typography fontWeight={600}>Κωδικός</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography fontWeight={600}>Περιγραφή</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography fontWeight={600}>Συντμηση</Typography>
                </Grid>
                <Grid item xs={2} textAlign="right">
                    <Typography fontWeight={600}>Ενεργή</Typography>
                </Grid>        <Grid item xs={2} textAlign="right">
                    <Typography fontWeight={600}>Ενέργεια</Typography>
                </Grid>
            </Grid>

            {/* Rows */}
            {rows.map((row, idx) => (
                <Grid
                    key={row.id || idx}
                    container
                    alignItems="center"
                    sx={{
                        backgroundColor: idx % 2 === 0 ? "#fafafa" : "#fff",
                        borderBottom: idx < rows.length - 1 ? "1px solid #e0e0e0" : "none",
                        py: 1.2,
                        px: 2,
                    }}
                >
                    <Grid item xs={2}>
                        <Typography color="primary" fontWeight={600}>
                            {row.id}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography>{row.description}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography>{row.abbr}</Typography>
                    </Grid>
                    <Grid item xs={2} textAlign="right">
                        <Typography>{row.isActive ? <Check color='success' /> : ""}</Typography>
                    </Grid>
                    <Grid item xs={2} textAlign="right">
                        <Tooltip title="Επεξεργασία">
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => onEdit?.(row)}
                            >
                                <Edit fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Διαγραφή">
                            <IconButton
                                size="small"
                                color="error"
                                onClick={() => onDelete?.(row)}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            ))}
        </Box>
    );
};

export default ApplicationTypesTable;
